import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Input, Label, FormGroup } from 'reactstrap';

import './pill-checkbox-item.scss';

export function PillCheckboxItem({ label, checked, onChange, ...rest }) {
  const id = useId();

  return (
    <FormGroup tag="li" className="pill-wrapper" noMargin key={label}>
      <Input id={id} type="checkbox" className="visually-hidden" checked={checked} onChange={onChange} {...rest} />
      <Label check for={id} className="p-1 mb-0 rounded-5">
        {label}
      </Label>
    </FormGroup>
  );
}

PillCheckboxItem.propTypes = {
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};
